import React, { useRef, forwardRef } from "react";
import { Box, createPolymorphicComponent, Paper } from "@mantine/core";
import { useMergedRef } from "@mantine/hooks";

export interface IDrawerFooterProps {
  children?: React.ReactNode;
}

export const _DrawerFooter = forwardRef<HTMLDivElement, IDrawerFooterProps>(
  (props, ref) => {
    const { children } = props;

    const itemRef = useRef<any>();

    return (
      <>
        {children && (
          <Paper
            p="sm"
            withBorder
            radius={0}
            ref={useMergedRef(itemRef, ref)}
            sx={{ position: "absolute", bottom: 0, left: 0, right: 0 }}
          >
            <Box>{children}</Box>
          </Paper>
        )}
      </>
    );
  }
);

_DrawerFooter.displayName = "@modir/ui-mantine/DrawerFooter";

export const DrawerFooter =
  createPolymorphicComponent<"div", IDrawerFooterProps>(_DrawerFooter);
